import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/authentication/services/authentication.service';
import { AdminNavigationItem } from '../../models/admin-navigation-itm';
import { IDeactivateComponent } from '../../../authentication/i-deactivate/i-deactivate.component';
import { AdminSettingsComponent } from '../admin-settings/admin-settings.component';
import { AdminNavigationComponent } from '../admin-navigation/admin-navigation.component';

@Component({
    selector: 'app-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.scss'],
    standalone: false,
})
export class AdminComponent implements OnInit, IDeactivateComponent {
    @ViewChild(AdminSettingsComponent)
    adminSettingsComponent?: AdminSettingsComponent;
    @ViewChild(AdminNavigationComponent)
    adminNavigation?: AdminNavigationComponent;

    isUserAdmin = false;
    private selectedNavItem: AdminNavigationItem;

    constructor(
        private authenticationService: AuthenticationService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.redirectIfUserisNotAdmin();
    }

    redirectIfUserisNotAdmin() {
        if (!this.authenticationService.isAdmin()) {
            this.router.navigateByUrl('**');
        } else {
            this.isUserAdmin = true;
        }
    }

    handleNavigationItemEvent(event: AdminNavigationItem): void {
        const isLeavingDirtySettings =
            this.isSettingsSelected() &&
            event !== AdminNavigationItem.Settings &&
            !!this.adminSettingsComponent &&
            !this.adminSettingsComponent.canExit();

        if (isLeavingDirtySettings) {
            this.adminNavigation?.resetSelection(AdminNavigationItem.Settings);
            return;
        }
        this.selectedNavItem = event;
    }

    isUserSelected(): boolean {
        return AdminNavigationItem.User === this.selectedNavItem;
    }

    isTrainingsSelected(): boolean {
        return AdminNavigationItem.Trainings === this.selectedNavItem;
    }

    isPerformanceSelected(): boolean {
        return AdminNavigationItem.Performance === this.selectedNavItem;
    }

    isTokenSelected(): boolean {
        return AdminNavigationItem.Token === this.selectedNavItem;
    }

    isCreditsSelected(): boolean {
        return AdminNavigationItem.Credits === this.selectedNavItem;
    }

    isSettingsSelected(): boolean {
        return AdminNavigationItem.Settings === this.selectedNavItem;
    }

    /**
     * Implementation of IDeactivateComponent interface.
     * Delegates to AdminSettingsComponent when the settings tab is active.
     */
    canExit(): boolean {
        if (this.isSettingsSelected() && this.adminSettingsComponent) {
            return this.adminSettingsComponent.canExit();
        }
        return true;
    }
}
